import { useConfiguratorStore } from '@eliadmin/core/src/stores/configurator-store';

export function useProformValidation() {
  const errorFields = useConfiguratorStore(s => s.errorFields);

  // const isValid = useMemo(() => {
  //   if (!confQuery.data) {
  //     return false;
  //   }

  //   const conf = confQuery.data.root.smako_conf.column;
  //   const requiredFields = cols.root.smako_conf_cols.column.filter(col => col.must === '1');
  //   const requiredKeysSet = new Set(requiredFields.map(field => field.column));

  //   if (!conf) {
  //     return false;
  //   }

  //   const errorKeys = Object.keys(errorFields);
  //   if (
  //     errorKeys.length > 0 &&
  //     errorKeys.some(key => errorFields[key] && requiredKeysSet.has(key))
  //   ) {
  //     return false;
  //   }

  //   for (const field of requiredFields) {
  //     const key = field.column as keyof typeof conf;
  //     if (field.column in conf && !conf[key]) {
  //       return false;
  //     }

  //     if (field.column === 'user_vyska') {
  //       const vyskaMax = parseProformNumber(conf.vyska_max);
  //       const vyskaMin = parseProformNumber(conf.vyska_min);
  //       const vyska = parseProformNumber(conf.user_vyska);

  //       if (vyskaMax === 0 && vyskaMin === 0) {
  //         continue;
  //       }

  //       if (isNaN(vyska)) {
  //         return false;
  //       }

  //       if (!isNaN(vyskaMax) && vyska > vyskaMax) {
  //         return false;
  //       }

  //       if (!isNaN(vyskaMin) && vyska < vyskaMin) {
  //         return false;
  //       }

  //       continue;
  //     }

  //     if (field.column === 'user_sirka') {
  //       const sirkaMax = parseProformNumber(conf.sirka_max);
  //       const sirkaMin = parseProformNumber(conf.sirka_min);
  //       const sirka = parseProformNumber(conf.user_sirka);

  //       if (sirkaMax === 0 && sirkaMin === 0) {
  //         continue;
  //       }

  //       if (isNaN(sirka)) {
  //         return false;
  //       }

  //       if (!isNaN(sirkaMax) && sirka > sirkaMax) {
  //         return false;
  //       }

  //       if (!isNaN(sirkaMin) && sirka < sirkaMin) {
  //         return false;
  //       }

  //       continue;
  //     }
  //   }

  //   return true;
  // }, [cols.root.smako_conf_cols.column, confQuery.data, errorFields]);

  const hasError = Object.keys(errorFields ?? []).some(key => errorFields[key]);

  return !hasError;
}
